import styled from "styled-components";

export const Container = styled.div`
  margin-top: 9px;
  padding: 0 16px;
  box-sizing: border-box;
`;

export const CreateHead = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & a {
    height: 24px;
  }

  & h1 {
    font-weight: 700;
    font-size: 1.125rem;
    text-align: center;
    letter-spacing: -0.02em;
    padding-left: 32%;
    margin: 9px 0;
  }
`;
export const ArrowBack = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const SelectCategory = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  padding-bottom: 12px;
  cursor: pointer;

  & h2 {
    font-weight: 400;
    font-size: 1rem;
    line-height: 24px;
    letter-spacing: -0.02em;
  }

  & img {
    width: 24px;
    height: 24px;
  }
`;

export const CategoryList = styled.div`
  & div {
    padding: 2px 0;
    max-width: 400px;
    margin-left: -16px;
    font-size: 0.8rem;
    color: #4a5056;
    background-color: #f8f9fa;
    & span {
      margin-left: 16px;
    }
  }

  & ul {
    & li {
      padding: 12px 0;
      margin: 1px 0;
      cursor: pointer;
      font-size: 0.9rem;
    }
  }
`;

export const WritingPost = styled.div`
  height: calc(100vh - 330px);
`;

export const DetailLine = styled.div`
  height: 1px;
  margin-left: -16px;
  background: #f1f3f5;
`;

export const Boldline = styled(DetailLine)`
  height: 8px;
`;

export const TextareaCreatePost = styled.textarea`
  width: 100%;
  height: calc(100vh - 345px);

  margin-top: 16px;
  border: none;
  outline: none;
  resize: none;

  &::placeholder {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
    color: #878e95;
  }

  ::-webkit-scrollbar {
    width: 4px;
    cursor: pointer;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #f1f3f5;
    border-radius: 4px;
    height: 170px;
    cursor: pointer;
  }
`;

export const BottomFixed = styled.div`
  position: fixed;
  bottom: 68px;
  width: 100%;
  padding-right: 32px;
  box-sizing: border-box;
`;

export const Attach = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 72px;
  bottom: 132px;

  border-top: 8px solid #f1f3f5;

  /* 카메라모양 버튼이미지 */
  & img {
    width: 48px;
    height: 48px;
    cursor: pointer;
  }
  /* 카메라모양 이미지 추가버튼 */
  & .imgAddBtn {
    width: 48px;
    height: 48px;
    cursor: pointer;
    border: 1px solid #dfe2e6;
    border-radius: 4px;
    text-align: center;
    box-sizing: border-box;

    & img {
      width: 18px;
      height: 18px;
      margin-bottom: -5px;
    }
    & div {
      font-size: 11px;
    }

    /* 사진선택 안했을 경우 */
    & .gray {
      color: #878e95;
    }
    /* 사진 1개이상 선택한 경우 */
    & span {
      color: #ff7a00;
    }
  }

  & .imageContainer {
    position: relative;
    margin-left: 8px;

    & .imageDelete {
      position: absolute;
      right: -6px;
      top: -6px;
      width: 16px;
      height: 16px;
    }

    & .image {
      border-radius: 4px;
    }
  }
`;

export const Registration = styled.div`
  & .impossible {
    padding-top: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
    background-color: #f8f9fa;
    cursor: pointer;

    & div {
      font-weight: 700;
      font-size: 16px;
      text-align: center;
      letter-spacing: -0.02em;
      color: #878e95;
    }
  }

  & .possible {
    padding-top: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
    background-color: #ff7a00;
    cursor: pointer;

    & div {
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      text-align: center;
      letter-spacing: -0.02em;
    }
  }
`;
